export default "__VITE_ASSET__88ddaed2__"